/**
 * Avatar — a generated, deterministic initials avatar (colored circle).
 *
 * No image upload needed: the initials come from the name and the colour is
 * derived from it, so each member gets a stable, distinct avatar.
 */

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Deterministic hue (0-359) from the name, for a stable background colour. */
function hueFor(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 360;
  return h;
}

export function Avatar({
  name,
  src,
  size = 36,
}: {
  name: string;
  src?: string | null;
  size?: number;
}) {
  const base = {
    width: size,
    height: size,
    flexShrink: 0,
    borderRadius: "50%",
  } as const;

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        style={{ ...base, objectFit: "cover", display: "block" }}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      style={{
        ...base,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: `hsl(${hueFor(name)}, 42%, 40%)`,
        color: "#fff",
        fontSize: size * 0.4,
        fontWeight: 600,
        lineHeight: 1,
        userSelect: "none",
      }}
    >
      {initials(name)}
    </span>
  );
}
